import React, { Component } from 'react';
import TextSearchWrapper from "../TextSearchWrapper";
import SmallTextSearchInner from "./SmallTextSearchInner";
export default class SmallTextSearch extends Component {
  render() {
    return /*#__PURE__*/React.createElement(TextSearchWrapper, {
      compact: true,
      extraProps: {
        onBlur: this.props.onBlur,
        onFocus: this.props.onFocus,
        screenClass: this.props.screenClass
      },
      filters: this.props.filters,
      onChange: this.props.onChange,
      perspective: this.props.perspective,
      searchComponent: SmallTextSearchInner,
      stateChangeRequested: this.props.stateChangeRequested
    });
  }
}